import React from 'react';
import { ListItemButton, ListItemText } from '@mui/material';
import { InsertDriveFileOutlined } from '@mui/icons-material';
import { useAgreementTemplateQuery } from '@uplift/queries';
import { CollaborativeAgreementSigned } from '@uplift/api';
import { CalendarDateService } from '@uplift/services';
import { DateFormats } from '@uplift/constants';
import { HighlightableAvatar } from '@uplift/ui-v2';


export const CollaborativeAgreementCounterSignedListItem: React.VFC<{
  document: CollaborativeAgreementSigned;
  onClick: () => void;
  selected: boolean;
}> = ({
  document,
  onClick,
  selected,
}) => {
  const { data: template } = useAgreementTemplateQuery(document.agreementTemplateId);

  return (
    <ListItemButton
      onClick={onClick}
      selected={selected}
      sx={selected ? { borderRight: '3px solid', borderRightColor: 'secondary.main' } : undefined}
    >
      <HighlightableAvatar variant="circular" highlighted={selected}>
        <InsertDriveFileOutlined fontSize="small" />
      </HighlightableAvatar>
      <ListItemText
        sx={{ ml: 1 }}
        primary={template.name}
        secondary={CalendarDateService.date(document.signedAt, DateFormats.ISO_DATE).format(DateFormats['MMM D, YYYY'])}
      />
    </ListItemButton>
  );
};
